import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CaseXDR } from '../../../shared/model/cybersocxdr/microsocticket';
import { PaginatedList } from 'src/app/shared/model/cybersocxdr/paginatedList';

@Component({
  selector: 'app-scrollable-incident-list',
  templateUrl: './scrollableIncidentList.component.html',
})
export class ScrollableIncidentListComponent {
  @Input()
  set currentPage(value: PaginatedList<CaseXDR>) {
    if (!value) return;

    //si pas de data sur la page fetch la page 0
    if (value.items.length === 0 && value.page > 0) this.fetchPage.emit(0);

    this._currentPage = value;
    if (value.page === 0) {
      this.cases = [...value.items];
    } else {
      this.cases = [...this.cases, ...value.items];
    }
    this.scrollLoading = false;
  }
  _currentPage: PaginatedList<CaseXDR>;

  cases: CaseXDR[] = [];

  @Output()
  fetchPage: EventEmitter<number> = new EventEmitter<number>();

  scrollLoading: boolean = false;

  public loadNextPage() {
    if (!this._currentPage || this.scrollLoading || this.cases.length >= this._currentPage.total) {
      return;
    }
    this.scrollLoading = true;
    this.fetchPage.emit(this._currentPage.page + 1);
  }
}
